import { Route as FastMovingRoute } from "@/routes/(inventory)/branch/_layout/reports/fast-moving-items/index";
import { useQuery } from "@tanstack/react-query";
import { getFastMovingItems } from "../-data/api";
import { FastMovingItemsReportResponse } from "@/gen/reports/fast_moving_items_report_pb";

interface ReportQueryResult {
  items: any[];
  totalCount: number;
  page: number;
  pageSize: number;
}

export const useFastMovingItemsData = () => {
  const searchParams = FastMovingRoute.useSearch();
  
  const page = searchParams.page || 1;
  const pageSize = searchParams.pageSize || 10;
  
  return useQuery<ReportQueryResult>({
    queryKey: ["fast-moving-items", searchParams],
    queryFn: async () => {
      const response = await getFastMovingItems(page, pageSize);
      
      return {
        items: response.fastMovingItems,
        totalCount: response.totalCount,
        page,
        pageSize,
      };
    },
    placeholderData: (previousData) => previousData,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};